import { Box } from '@chakra-ui/react'
import React from 'react'
import { usePhoneHub } from '~/hooks/usePhone'

import { IncomingCallModal } from './IncomingCallModal'

const CALL_AUDIO_ELEMENT_ID = 'callAudio'

export const PhoneHub = () => {
  usePhoneHub(CALL_AUDIO_ELEMENT_ID)

  return (
    <Box position="absolute">
      <audio id={CALL_AUDIO_ELEMENT_ID} autoPlay />
      <IncomingCallModal />
    </Box>
  )
}
